// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"21d0d86d","422":"062952f7","509":"dd98a548","831":"71f731bf","888":"f037fc8b"}[chunkId] + ".chunk.js";
};